<template>
  <div v-if="subjects">
    <mdb-tabs default :active="active" @activeTab="onActiveTab"
      :links="[
        { text: `NCS 교과(${subjects.NCS.length})`},
        { text: `비 NCS 교과(${subjects.NONNCS.length})`}
      ]"/>
    <div class="mt-3">
      <plans-edit v-if="active === 0" :subjects="subjects.NCS" />
      <plans-edit v-if="active === 1" :subjects="subjects.NONNCS" />
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Training from '@/models/Training'
import PlansEdit from '../../../../components/subject/PlansEdit.vue'
export default {
  name: 'StaffOpenTrainingPlan',
  components: { mdbTabs, PlansEdit },
  data () {
    return {
      TAG: 'StaffOpenTrainingPlan >>',
      subjects: undefined
    }
  },
  computed: {
    training () {
      return this.$route.query.training
    },
    active () {
      return parseInt(this.$route.query.active) || 0
    }
  },
  methods: {
    async load () {
      this.subjects = await this.$getSubjects(this.training)
    },
    onActiveTab (index) {
      this.$router.push({
        query: {
          ...this.$route.query,
          active: index
        }
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
